import { Close } from "@mui/icons-material";
import { Box, IconButton, Modal } from "@mui/material" 


const lightBoxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  outline: 0,
};

const closeButtonStyle = {
  position: "fixed",  
  top: 16,
  right: 16,
  zIndex: 1301,
  color: 'white'
};

export const LightBox = ({
  image, 
  open, 
  onClose
}:{
  image:string, 
  open: boolean, 
  onClose: Function
}) => {
  return (
    <Modal
      open={open}
      onClose={() => onClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      >
        <>
          <IconButton sx={closeButtonStyle} onClick={() => onClose()}>
            <Close/>
          </IconButton>
          <Box sx={lightBoxStyle}>
            <img src={image} style={{display:"block", maxWidth: "60vw", maxHeight:"80vh"}}/>
          </Box>
        </>
    </Modal>
  );
};

